/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seemly_Low_Pony_ComposeInputs */

const fr_seemly_low_pony_compose = /** @type {(inputs: Seemly_Low_Pony_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des permissions`)
};

/**

* @param {Seemly_Low_Pony_ComposeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const seemly_low_pony_compose = /** @type {((inputs?: Seemly_Low_Pony_ComposeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seemly_Low_Pony_ComposeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_seemly_low_pony_compose(inputs)
});